module.exports = __webpack_public_path__ + "static/img/032 11.4f54691c.jpg";